import { Pipe, PipeTransform } from '@angular/core';
import { LssDeploymentEntity } from '../store/deployment.datamodel';

/**
 * Pipe to determine the indeterminate state of a checkbox.
 */
@Pipe({
    name: 'indeterminateState',
    standalone: false
})
export class IndeterminateStatePipe implements PipeTransform {

  transform(entities: LssDeploymentEntity[], property: 'isDeployed' | 'isExcluded'): boolean {
    return entities.some((entity: LssDeploymentEntity) => entity[property])
    && entities.some((entity: LssDeploymentEntity) => !entity[property]);
  }

}
